export default __webpack_public_path__ + "static/media/svg-1.bd6551d5.svg";